import { render } from "./form-part-b-investment-money.html?vue&type=template&id=d668efb4&scoped=true&ts=true&external"
import script from "./form-part-b-investment-money.ts?vue&type=script&lang=ts&external"
export * from "./form-part-b-investment-money.ts?vue&type=script&lang=ts&external"

import "./form-part-b-investment-money.scss?vue&type=style&index=0&id=d668efb4&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d668efb4"]])

export default __exports__